import React from 'react';
import { IconType } from 'react-icons';

interface IconWrapperProps {
  icon: IconType;
  size?: number;
  style?: React.CSSProperties;
  color?: string;
}

const IconWrapper: React.FC<IconWrapperProps> = ({ icon: IconComponent, size = 20, style, color }) => {
  return React.createElement(IconComponent as any, { size, style, color });
};

export default IconWrapper;
